import { useState, type DragEvent, type ReactNode } from 'react';
import { FileUp } from 'lucide-react';
import { cn } from '../../lib/cn';
import { Icon, type LucideIcon } from '../ui/icon';

export interface DropZoneProps {
  icon?: LucideIcon;
  title: ReactNode;
  /** Welche Formate. */
  description?: ReactNode;
  /** Button „Datei wählen…“; die Dateiauswahl bleibt beim Aufrufer. */
  action?: ReactNode;
  /** Von außen erzwingen; sonst während eine Datei darüber gezogen wird. */
  active?: boolean;
  /** Abgelegte Dateien. Ohne Handler ist die Fläche nur Anzeige. */
  onFiles?: (files: File[]) => void;
  className?: string;
}

/** Gestricheltes Ziel für Dateien: Fotos, Aufmaß, Angebote als PDF. */
export function DropZone({ icon = FileUp, title, description, action, active, onFiles, className }: DropZoneProps) {
  const [darueber, setDarueber] = useState(false);
  const an = active ?? darueber;
  const handler = onFiles
    ? {
        onDragOver: (e: DragEvent) => {
          e.preventDefault();
          setDarueber(true);
        },
        onDragLeave: () => setDarueber(false),
        onDrop: (e: DragEvent) => {
          e.preventDefault();
          setDarueber(false);
          onFiles(Array.from(e.dataTransfer.files));
        },
      }
    : {};
  return (
    <div
      {...handler}
      className={cn(
        'flex items-center gap-4 rounded-lg border-[1.5px] border-dashed border-input px-6 py-5 transition-colors duration-150',
        an && 'border-ring bg-highlight-soft',
        className,
      )}
    >
      <Icon icon={icon} size={26} className="text-highlight" />
      <div className="min-w-0 flex-1">
        <div className="t-title">{title}</div>
        {description && <div className="t-small text-muted-foreground">{description}</div>}
      </div>
      {action}
    </div>
  );
}
